export const processTags = (tags?: string) => {
  if (!tags) {
    return []
  }

  return tags
    .split(',')
    .map((tag) => tag.trim())
    .filter((tag) => tag.length > 0)
}
